import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { Box, Theme, Typography } from "@outschool/backpack";
import { ContentfulMagnetPage } from "@outschool/gql-backend-generated";
import React from "react";

export default function HeaderMagnetPage({
  magnetPage
}: {
  magnetPage: ContentfulMagnetPage;
}) {
  return (
    <>
      <Box
        flex
        sx={{
          flexDirection: "column"
        }}
      >
        <Box
          sx={(theme: Theme) => ({
            height: "302px",
            backgroundImage: `url("${magnetPage?.headerImage?.url}")`,
            backgroundPosition: "center center",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            borderRadius: "0.5em",
            [theme.breakpoints.down("md")]: {
              height: "202px"
            }
          })}
        />

        {magnetPage?.title && (
          <Typography
            variant="h1"
            sx={(theme: Theme) => ({
              marginTop: theme.spacing(56),
              fontSize: `${theme.typography.pxToRem(36)} !important`
            })}
          >
            {magnetPage?.title}
          </Typography>
        )}

        {magnetPage?.summary && (
          <Box
            size="xsmall"
            sx={(theme: Theme) => ({
              marginTop: theme.spacing(12),
              marginBottom: theme.spacing(36),
              fontSize: theme.typography.pxToRem(21),
              lineHeight: "32px",
              fontWeight: 500
            })}
          >
            {documentToReactComponents(magnetPage?.summary.json)}
          </Box>
        )}
      </Box>
    </>
  );
}
